/* eslint-disable react/prefer-stateless-function */
import React from "react";
import PropTypes from "prop-types";
import HorBarChart from "./HorBarChart";
import { formatUnix, formatComma } from "../utils/dataHelpers/formatters";

class Body extends React.Component {
  render() {
    const { data } = this.props;
    const { prisonData } = data;
    return (
      <div className="body__container">
        <HorBarChart
          data={prisonData}
          xAxisKey="date"
          yAxisKey="totalPrisonerCases"
          xAxisTickFormatter={formatUnix}
          tooltipLabelFormatter={formatUnix}
          yAxisTickFormatter={formatComma}
          yAxisWidth={50}
        />
      </div>
    );
  }
}

Body.propTypes = {
  data: PropTypes.objectOf(PropTypes.array).isRequired,
};

export default Body;
